import React from 'react';
import { CheckIcon, MoonIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { pillars, method, audience, PRODUCT } from '../data/content';
export function MethodSection() {
  return <section aria-labelledby="metodo" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-153" data-mp="2tgtfthull7t">
      <Reveal data-id="element-154" data-mp="3uzm0pqsxy44p">
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-blush" data-id="element-155" data-mp="3uzuh3so9vrkn">
          El sistema de
        </p>
        <h2 id="metodo" className="mt-2 flex items-center justify-center gap-2 font-display text-2xl md:text-3xl font-bold uppercase leading-tight text-ink" data-id="element-156" data-mp="vkqozwgvh47a">
          <MoonIcon size={22} className="text-accent" data-id="element-157" data-mp="lr02gx4b33u8" />
          {PRODUCT}
        </h2>
        <p className="mx-auto mt-3 max-w-3xl text-base text-ink-muted" data-id="element-158" data-mp="hr97sibns3kf">
          Diseñado para mujeres que quieren dejar de vivir en piloto automático
          y comenzar a{' '}
          <span className="font-semibold text-ink" data-id="element-159" data-mp="19hvu9u8rhz1h">escucharse nuevamente</span>.
        </p>
      </Reveal>

      <ol className="mt-8 grid gap-3 md:grid-cols-3" data-id="element-160" data-mp="1v2r10351yr7h">
        {pillars.map((pillar, i) => <Reveal key={pillar.title} as="li" delay={i * 0.04} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-6 text-center" data-id="element-161" data-mp="2000ovecsmut7" data-mpi={i}>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-soft font-display text-base font-bold text-accent" data-id="element-162" data-mp="1q9fopmhh1i86">
              {i + 1}
            </span>
            <h3 className="mt-3 font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-163" data-mp="1hc5g68w1g76y">
              {pillar.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-164" data-mp="17cemg9faxw7x">
              {pillar.desc}
            </p>
          </Reveal>)}
      </ol>

      <Reveal delay={0.06} className="mt-6 rounded-2xl border border-accent/20 bg-accent-soft p-6 md:p-8" data-id="element-165" data-mp="2wsdwdsqqvpom">
        <h3 className="font-display text-xl font-bold uppercase tracking-wide text-accent" data-id="element-166" data-mp="309ih71nnthxw">
          Método VUELVE™
        </h3>
        <ul className="mx-auto mt-5 grid max-w-4xl gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-167" data-mp="2va5s0a9bfys5">
          {method.map(step => <li key={step.title} className="flex flex-col items-center rounded-xl bg-surface px-4 py-4 text-center" data-id="element-168" data-mp="2qbujc2urbubi">
              <span className="font-display text-2xl font-bold text-blush" data-id="element-169" data-mp="3j0jbhcdu4pb4">
                {step.letter}
              </span>
              <span className="mt-1 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-170" data-mp="3e283z8b0iqw2">
                {step.title}
              </span>
              <span className="mt-1 text-sm text-ink-muted" data-id="element-171" data-mp="397u3irhhttkj">{step.desc}</span>
            </li>)}
        </ul>
      </Reveal>

      <Reveal delay={0.08} className="mt-6" data-id="element-172" data-mp="5ln4ci49ta5m">
        <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-blush" data-id="element-173" data-mp="5meo8voi9jg2">
          Pensado especialmente para
        </h3>
        <ul className="mx-auto mt-4 grid max-w-4xl gap-2 sm:grid-cols-2" data-id="element-174" data-mp="1jh4xj6dr659e">
          {audience.map(item => <li key={item} className="flex items-center justify-center gap-2 rounded-xl border border-line bg-surface px-4 py-3 text-sm text-ink" data-id="element-175" data-mp="1ofpwl2h9qiw9">
              <CheckIcon size={14} className="flex-shrink-0 text-accent" strokeWidth={3} data-id="element-176" data-mp="1xgo2xrf6j2i0" />
              <span data-id="element-177" data-mp="22fhgfjuguti6">{item}</span>
            </li>)}
        </ul>
      </Reveal>
    </section>;
}